import { fold } from './fold';
import { prettyPrint } from './pretty-print';
import { parseZodToResult as parseToResult } from './parse-zod-to-result';
import { ZodAlgebra } from './fold';
import { unwrapZodSchema } from './unwrap-zod-schema';
import { zodToJsonSchema, isValidToolJsonSchema } from './zod-to-json-schema';

export const ZodUtils = {
  fold,
  prettyPrint,
  parseToResult,
  unwrapZodSchema,
  zodToJsonSchema,
  isValidToolJsonSchema,
};

export type { ZodAlgebra };
export type { JsonSchema } from './zod-to-json-schema';
